// extracted by mini-css-extract-plugin
module.exports = {"container":"servicesSlider_container__DWOvK","title":"servicesSlider_title__fwaxK","text":"servicesSlider_text___aBgR","desktop":"servicesSlider_desktop__NHSat"};